var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77778 1H3.22222V2.11111H2.11111V3.22222H1V8.77778H2.11111V9.88889H3.22222V11H8.77778V9.88889H9.88889V8.77778H11V3.22222H9.88889V2.11111H8.77778V1ZM8.77778 2.11111V3.22222H9.88889V8.77778H8.77778V9.88889H3.22222V8.77778H2.11111V3.22222H3.22222V2.11111H8.77778Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonS);
export default __webpack_public_path__ + "static/media/common-s.d1602fcc1e77cab6a086ac59fa097fe0.svg";
export { ForwardRef as ReactComponent };